import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllMarksUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllMarksOrder/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarksUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllMarksUser;
};


const setActiveMarks = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setMarksOrderActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarksUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Marks  - ',response);


    return AllMarksUser;
};



const setDeletedMarks = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setMarksOrderDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarksUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Marks  - ',response);


    return AllMarksUser;
};




const setUpdateMarks = async (dataMarksOrderUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setMarksOrderUpdate/'),{
        dataMarksOrderUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarksUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Marks  - ',dataMarksOrderUpdate,response);


    return AllMarksUser;
};


const setSaveNewMarks = async (dataMarksOrderUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewMarksOrder/'),{
        dataMarksOrderUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllMarksUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Marks  - ',response);


    return AllMarksUser;
};

Mock.onGet('/api/reference/getAllMarks').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllMarksUser = await getAllMarksUser();
    // console.log('С сервера пришло - ', AllMarksUser);

    // if (!AllMarksUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllMarksUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarksUser,
    ]


})


Mock.onPost('/api/reference/setActiveMarks').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllMarksUser = await setActiveMarks(id,val);

    // if (!AllMarksUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllMarksUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarksUser,
    ]


})

Mock.onPost('/api/reference/setDeletedMarks').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllMarksUser = await setDeletedMarks(id,val);

    // if (!AllMarksUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllMarksUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllMarksUser,
    ]


})


Mock.onPost('/api/reference/setUpdateMarks').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataMarksUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Marks = await setUpdateMarks(dataMarksUpdate);

    // console.log('Серовер вернул данные ',AllMarksUser);

    // if (!Marks) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Marks) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Marks,
    ]


})


Mock.onPost('/api/reference/setSaveNewMarks').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataMarksUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Marks = await setSaveNewMarks(dataMarksUpdate);

    // console.log('Серовер вернул данные ',AllMarksUser);

    // if (!Marks) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Marks) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Marks,
    ]
})